module.exports = __webpack_public_path__ + "static/media/collecte.e9e133cd.svg";